<header>
  <img src="/assets/collabo-portal/images/logo.svg" alt="" />
</header>

<!-- <main>
  <div id="login">
    <p class="login">ログイン</p>
    <form (submit)="login()">
      <div class="form">
        <input type="text" [(ngModel)]="email" name="email" />
      </div>
      <div class="form">
        <input type="password" [(ngModel)]="password" name="password" />
      </div>

      <div><button type="submit" class="submit">ログイン</button></div>
    </form>
  </div>
</main> -->

<main class="frame44">
  <div class="frame45">
    <content>
      <p class="login">ログイン</p>
      <form (submit)="login()">
        <div class="inputs">
          <input
            type="text"
            name="email"
            placeholder="メールアドレス"
            [(ngModel)]="email"
          />
          <input
            type="password"
            name="password"
            placeholder="パスワード"
            [(ngModel)]="password"
          />
          <!-- <app-mdi-eye [show]="false"></app-mdi-eye> -->
        </div>
        <div class="frame4">
          <button class="login" type="submit"><p>ログイン</p></button>
        </div>
      </form>
      <div class="frame41">
        <div class="frame42">
          <a href="">パスワードをお忘れの方はこちら</a>
        </div>
        <!-- <div>
          <p></p>
        </div> -->
      </div>
      <!-- v1では無効化 -->
      <!-- <div class="divider"></div>
      <div class="frame1">
        <p>アカウントをお持ちでない方</p>
        <button class="register"><p>新規登録</p></button>
      </div> -->
      <div class="frame42">
        <a href="">認証メールが届かない方はこちら</a>
      </div>
    </content>
  </div>
</main>
